import React from "react";
import { connect } from "react-redux";

import HaleonEvents from "./HaleonEvents";

const HaleonEventsContainer = props => {
  return <HaleonEvents {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(HaleonEventsContainer);



// WEBPACK FOOTER //
// src/pages/sidely/HaleonEvents.container.js